(() => {
  'use strict';

  const isDiscoveryKitPage = document.body.classList.contains('discovery-kit') ||
    document.body.classList.contains('product-discovery-kit');
  const isCartPage = document.body.classList.contains('cart');

  if (!isDiscoveryKitPage && !isCartPage) {
    document.getElementById('dk-discovery-config')?.remove();
  }

  document.querySelectorAll('.musk-main-header.logo_center').forEach(header => {
    header.classList.remove('logo_center');
    header.classList.add('logo_left');
  });

  const moveProductIconSection = () => {
    if (!document.body.classList.contains('product')) return;
    const details = document.querySelector(
      '[id$="__product_information_BDQGiN"] .product-details-card-sticky-inner'
    );
    const iconSection = document.querySelector('[id$="__icon_with_text_rWLDUD"]');
    if (!details || !iconSection || details.contains(iconSection)) return;
    iconSection.classList.add('dk-icon-section-in-product-info');
    details.append(iconSection);
  };

  moveProductIconSection();
  document.addEventListener('DOMContentLoaded', moveProductIconSection, { once: true });
})();

(() => {
  'use strict';
  const isDiscoveryKitPage = document.body.classList.contains('discovery-kit') ||
    document.body.classList.contains('product-discovery-kit');
  if (!isDiscoveryKitPage) return;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const configNode = () => document.getElementById('dk-discovery-config');
  const getConfig = () => {
    const node = configNode();
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  };
  const statusNode = () => document.getElementById('dk-discovery-status');
  const showStatus = (message, error = false) => {
    const node = statusNode();
    if (!node) return;
    node.textContent = message;
    node.classList.toggle('is-error', error);
  };
  const candidates = (element) => {
    const values = [];
    if (!element) return values;
    for (const name of ['value', 'title', 'aria-label', 'data-value', 'data-label', 'data-option-value']) {
      const value = element.getAttribute && element.getAttribute(name);
      if (value) values.push(normalize(value));
    }
    if (element.textContent) values.push(normalize(element.textContent));
    return values.filter(Boolean);
  };
  const findItem = (element, items) => {
    const all = [...candidates(element)];
    const owner = element && element.closest ? element.closest('label, [data-value], [data-option-value], [class*="swatch"]') : null;
    if (owner && owner !== element) all.push(...candidates(owner));
    const label = element && element.id ? document.querySelector('label[for="' + CSS.escape(element.id) + '"]') : null;
    all.push(...candidates(label));
    const entries = Object.entries(items).sort((a, b) => b[0].length - a[0].length);
    return entries.find(([title]) => all.some(value => value === title || value.includes(title))) || null;
  };
  const checkedItems = (config) => {
    const found = new Map();
    document.querySelectorAll('input[type="checkbox"]:checked, [role="checkbox"][aria-checked="true"]').forEach(input => {
      const match = findItem(input, config.items);
      if (match) found.set(match[0], match[1]);
    });
    return Array.from(found, ([title, item]) => ({ title, ...item }));
  };
  const decorateSwatches = (config) => {
    const scope = document.querySelector('.gpo-app, .gpo-container, [data-gpo-app], [class*="globo"]') || document;
    scope.querySelectorAll('label, button, [role="checkbox"], [data-value], [data-option-value]').forEach(element => {
      if (element.dataset.dkImageReady === '1') return;
      const match = findItem(element, config.items);
      if (!match) return;
      const [title, item] = match;
      element.dataset.dkImageReady = '1';
      element.classList.add('dk-swatch-image');
      element.style.setProperty('--dk-swatch-image', 'url("' + item.image.replace(/"/g, '%22') + '")');
      element.setAttribute('data-dk-title', title);
    });
  };
  const updateSummary = () => {
    const config = getConfig();
    if (!config) return;
    decorateSwatches(config);
    const count = checkedItems(config).length;
    showStatus(count + ' of 4 selected · Total: Dhs. 30.00', count > 4);
  };
  let addInProgress = false;
  const addKit = async (form) => {
    const config = getConfig();
    if (!config) return false;
    const selected = checkedItems(config);
    if (selected.length !== 4) {
      showStatus('Choose exactly 4 fragrances before adding the kit.', true);
      return true;
    }
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(response => response.json());
    if (cart.items.some(item => Number(item.variant_id) === Number(config.parentVariantId))) {
      showStatus('Only one Discovery Kit can be added at a time.', true);
      return true;
    }
    const group = 'DK-' + Date.now().toString(36);
    const properties = {
      '_discovery_kit_group': group,
      '_discovery_kit_role': 'parent'
    };
    selected.forEach((item, index) => {
      properties['Fragrance ' + (index + 1)] = item.title;
    });
    const items = [{
      id: config.parentVariantId,
      quantity: 1,
      properties
    }];
    showStatus('Adding your Discovery Kit…');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });
    if (!response.ok) {
      const problem = await response.json().catch(() => ({}));
      throw new Error(problem.description || 'The Discovery Kit could not be added.');
    }
    window.location.assign('/cart');
    return true;
  };
  const submitKit = (form) => {
    if (addInProgress) return;
    addInProgress = true;
    addKit(form)
      .catch(error => showStatus(error.message, true))
      .finally(() => { addInProgress = false; });
  };
  document.addEventListener('submit', event => {
    const config = getConfig();
    if (!config) return;
    const form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitKit(form);
  }, true);
  document.addEventListener('click', event => {
    const config = getConfig();
    if (!config) return;
    const button = event.target.closest && event.target.closest('button[type="submit"], input[type="submit"], button[name="add"]');
    const form = button && button.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitKit(form);
  }, true);
  document.addEventListener('change', event => {
    const config = getConfig();
    if (config && event.target && event.target.matches('input[type="checkbox"]') && event.target.checked && checkedItems(config).length > 4) {
      event.target.checked = false;
      event.stopImmediatePropagation();
      showStatus('Choose only 4 fragrances. Remove one before selecting another.', true);
      return;
    }
    updateSummary();
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest && event.target.closest('#dk-discovery-status')) return;
    setTimeout(updateSummary, 0);
  }, true);
  const boot = () => {
    updateSummary();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        updateSummary();
      }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();

(() => {
  'use strict';

  if (document.body.classList.contains('product-dk-addon')) {
    window.location.replace('/products/discovery-kit');
    return;
  }

  const isDiscoveryKit = document.body.classList.contains('discovery-kit') ||
    document.body.classList.contains('product-discovery-kit');

  if (!isDiscoveryKit) return;

  let picker = null;

  const kitItems = (() => {
    try {
      return JSON.parse(document.getElementById('dk-discovery-config')?.textContent || '{}').items || {};
    } catch (error) {
      return {};
    }
  })();

  const selectedItems = () => {
    const selected = new Map();
    document.querySelectorAll('.gpo-container input[type="checkbox"]:checked').forEach(input => {
      const label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      const title = label?.dataset.dkTitle || input.value || label?.textContent;
      if (!title) return;
      const name = String(title).replace(/\s+/g, ' ').trim();
      selected.set(name, { name, image: kitItems[name]?.image || '' });
    });
    return Array.from(selected.values());
  };

  const updatePicker = () => {
    if (!picker) return;
    const items = selectedItems();
    const count = items.length;
    picker.count.textContent = count + ' of 4 selected';
    picker.done.disabled = count !== 4;

    const heading = document.createElement('strong');
    heading.textContent = 'Included fragrances:';
    const details = document.createTextNode(count
      ? ' ' + items.map(item => item.name).join(', ')
      : ' No fragrances selected yet.');
    picker.summary.replaceChildren(heading, details);

    const thumbnails = items
      .filter(item => item.image)
      .map(item => {
        const image = document.createElement('img');
        image.className = 'dk-included-thumb';
        image.src = item.image;
        image.alt = item.name;
        image.loading = 'lazy';
        return image;
      });
    picker.images.replaceChildren(...thumbnails);
  };

  const openPicker = () => {
    if (!picker) return;
    if (typeof picker.dialog.showModal === 'function') picker.dialog.showModal();
    else picker.dialog.setAttribute('open', '');
    document.body.classList.add('dk-picker-open');
    picker.close.focus();
  };

  const closePicker = () => {
    if (!picker) return;
    if (typeof picker.dialog.close === 'function') picker.dialog.close();
    else picker.dialog.removeAttribute('open');
    document.body.classList.remove('dk-picker-open');
    picker.trigger.focus();
  };

  const setupPicker = () => {
    if (picker) return true;

    const options = document.querySelector('.gpo-container');
    const status = document.getElementById('dk-discovery-status');
    if (!options || !status) return false;

    const launch = document.createElement('div');
    launch.className = 'dk-picker-launch';
    launch.innerHTML = '<button class="dk-picker-trigger" type="button" aria-haspopup="dialog">Choose your 4 fragrances</button>' +
      '<p class="dk-included-products" aria-live="polite"></p>' +
      '<div class="dk-included-images" aria-live="polite"></div>' +
      '<dialog class="dk-picker-dialog" aria-labelledby="dk-picker-title">' +
      '<div class="dk-picker-header"><h2 class="dk-picker-title" id="dk-picker-title">Choose 4 fragrances</h2>' +
      '<button class="dk-picker-close" type="button" aria-label="Close fragrance selector">&times;</button></div>' +
      '<div class="dk-picker-body"></div>' +
      '<div class="dk-picker-footer"><span class="dk-picker-count">0 of 4 selected</span>' +
      '<button class="dk-picker-done" type="button" disabled>Done</button></div></dialog>';

    status.insertAdjacentElement('afterend', launch);

    const dialog = launch.querySelector('.dk-picker-dialog');
    const trigger = launch.querySelector('.dk-picker-trigger');
    const close = launch.querySelector('.dk-picker-close');
    const done = launch.querySelector('.dk-picker-done');
    const count = launch.querySelector('.dk-picker-count');
    const summary = launch.querySelector('.dk-included-products');
    const images = launch.querySelector('.dk-included-images');
    dialog.querySelector('.dk-picker-body').appendChild(options);

    picker = { dialog, trigger, close, done, count, summary, images };

    trigger.addEventListener('click', openPicker);
    close.addEventListener('click', closePicker);
    done.addEventListener('click', closePicker);
    dialog.addEventListener('close', () => {
      document.body.classList.remove('dk-picker-open');
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) closePicker();
    });
    dialog.addEventListener('change', () => setTimeout(updatePicker, 0));

    updatePicker();
    return true;
  };

  const boot = () => {
    if (setupPicker()) return;
    const observer = new MutationObserver(() => {
      if (setupPicker()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();

(() => {
  'use strict';

  if (!document.body.classList.contains('cart')) return;

  const getConfig = () => {
    try {
      return JSON.parse(document.getElementById('dk-discovery-config')?.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const removeAddonCharges = async () => {
    const config = getConfig();
    const addonVariantIds = new Set(Object.values(config.items || {}).map(item => Number(item.variantId)));
    if (!addonVariantIds.size) return;

    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(response => response.json());
    const hasKit = cart.items.some(item => Number(item.variant_id) === Number(config.parentVariantId));
    if (!hasKit) return;
    const updates = {};
    cart.items.forEach(item => {
      if (addonVariantIds.has(Number(item.variant_id))) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Discovery Kit add-on charges could not be removed.');
    window.location.reload();
  };

  const boot = () => {
    removeAddonCharges().catch(() => {});
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
